@if (config) {
  @if (config.displayLevel === 'screen') {
    <div>
      DEBUG INFORMATION:
      <pre>{{ configAsJson }}</pre>
    </div>
  }
}
